import React, { useEffect } from 'react';
import { App } from '@capacitor/app';
import supabase from '@/shared/api/supabase';

const AppUrlListener: React.FC = () => {
  useEffect(() => {
    App.addListener('appUrlOpen', async (data) => {
      if (data.url?.includes('access_token')) {
        const queryParams = data.url.split('#')[1];
        const params = new URLSearchParams(queryParams);

        const access_token = params.get('access_token');
        const refresh_token = params.get('refresh_token');

        if (access_token && refresh_token) {
          const { error } = await supabase.auth.setSession({
            access_token,
            refresh_token,
          });
          if (error) console.error('Error setting session:', error.message);
        }
      }
    });
  }, []);

  return null;
};

export default AppUrlListener;
